<ng-container *ngIf="state$ | async as state">
    <div *ngIf="state.visible" class="payment-alert-banner" [ngClass]="{ 'is-warning': state.tone === 'warning', 'is-danger': state.tone === 'danger' }">
        <div class="payment-alert-content">
            <div class="payment-alert-message">
                <span class="payment-alert-icon-sonar">
                    <i-feather [name]="state.iconName" class="payment-alert-icon"></i-feather>
                </span>
                <span>{{ state.message }}</span>
            </div>
            <div class="payment-alert-actions">
                <button type="button" class="btn btn-payment-alert-action" (click)="onActionClick(state.action)">{{ state.actionLabel }}</button>
            </div>
        </div>
        <button *ngIf="state.dismissible" type="button" class="btn-payment-alert-close" (click)="onDismiss()" aria-label="Ocultar alerta">
            <i-feather name="x" aria-hidden="true" class="payment-alert-close-icon"></i-feather>
        </button>
    </div>
</ng-container>
